import { Box } from '@mui/material';

import DetailsItem from '../../../../../../common/details-item';
import { formatDateToClientFormat } from '../../../../../../../constants/helpers/dates';
import { reportDetailsFilterValuesFormatter } from '../../../../../../../utils/details';

import locales from '../../locales';
import { AccountTransfersReportDetailsMetadataResponse } from '../interfaces';

interface Props {
  filters: AccountTransfersReportDetailsMetadataResponse;
}

const DetailsSummary = ({ filters }: Props) => (
  <Box>
    <DetailsItem
      label={locales.common.filters.startingDate.label}
      value={formatDateToClientFormat({ date: filters.timeRange.from })}
    />
    <DetailsItem
      label={locales.common.filters.endDate.label}
      value={formatDateToClientFormat({ date: filters.timeRange.to, type: 'exclusive' })}
    />
    <DetailsItem
      label={locales.common.filters.statuses.label}
      value={reportDetailsFilterValuesFormatter(filters.statuses)}
    />
    <DetailsItem
      label={locales.common.filters.operationIds.label}
      value={reportDetailsFilterValuesFormatter(filters.operationIds)}
    />
    <DetailsItem
      label={locales.common.filters.senderPhoneNumber.label}
      value={reportDetailsFilterValuesFormatter(filters.sendersMsisdns)}
    />
  </Box>
);

export default DetailsSummary;
